import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation,} from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import PageBuilder from './components/PageBuilder';
import PageList from './components/PageList';
import AuthCard from './components/AuthCard';
import AdminPermissions from './components/AdminPermissions';
import ViewPageWrapper from './routes/ViewPageWrapper';
import { UserContext } from './context/UserContext';
import InactivityHandler from './components/InactivityHandler';
import Profile from './components/Profile';
import EmployeeProfile from './components/EmployeeProfile';
import EnrolledCourses from './components/students/EnrolledCourses';
import Footer from './components/includes/Footer';
import ScheduleMeeting from './components/meetings//ScheduleMeeting';
import Spline from '@splinetool/react-spline';
import './App.css'; // Import the new CSS file
import MeetingList from './components/meetings/MeetingList';
import MeetingEmbedPage from './routes/MeetingEmbedPage';
import RecordingsPage from './components/meetings/RecordingsPage';



const AppLayout = ({ user, onLogout }) => {
 const location = useLocation();
 const shouldHideNavbar = location.pathname === '/';

 const [isNavigating, setIsNavigating] = useState(false);

 useEffect(() => {
  setIsNavigating(true);
  const timer = setTimeout(() => setIsNavigating(false), 600);
  return () => clearTimeout(timer);
 }, [location.pathname]);

 return (
  <UserContext.Provider value={user}>
   {!shouldHideNavbar && <Navbar user={user} onLogout={onLogout} />}

   <AnimatePresence mode="wait">
    <motion.div
     key={location.pathname}
     initial={{ opacity: 0, y: 20 }}
     animate={{ opacity: 1, y: 0 }}
     exit={{ opacity: 0, y: -20 }}
     transition={{ duration: 0.5 }}
    >
     <Routes location={location} key={location.pathname}>
      <Route path="/" element={<Navigate to="/home" />} />
      <Route path="/home" element={<ProtectedRoute element={<Dashboard />} />} />
      <Route path="/courses" element={<ProtectedRoute element={<EnrolledCourses />} />} />
      <Route path="/create" element={<ProtectedRoute element={<PageBuilder />} requiredRole="superAdmin" />} />
      <Route path="/edit/:id" element={<ProtectedRoute element={<PageBuilder />} requiredRole="superAdmin" />} />
      <Route path="/profile" element={<ProtectedRoute element={<Profile />} />} />
      <Route path="/employee-profile" element={<EmployeeProfile />} />
      <Route path="/pages" element={<ProtectedRoute element={<PageList />} requiredRole="superAdmin" />} />
      <Route path="/grant-access" element={<ProtectedRoute element={<AdminPermissions />} requiredRole={["admin", "superAdmin"]} />} />
      
          <Route path="/meeting" element={<ProtectedRoute element={<ScheduleMeeting />} requiredRole={["admin", "superAdmin","trainer"]} />} />
            <Route path="/getmeeting" element={<ProtectedRoute element={<MeetingList />} requiredRole={["admin", "superAdmin","trainer"]} />} />
           <Route path="/edit-meeting" element={<ProtectedRoute element={<ScheduleMeeting  />} requiredRole={["admin", "superAdmin","trainer"]} />}/>
            <Route path="/meeting/:meetingKey" element={<ProtectedRoute element={<MeetingEmbedPage />} />} />
            <Route path="/recordings" element={<ProtectedRoute element={<RecordingsPage />} />} />
      <Route path="/view/:id" element={<ViewPageWrapper />} />
      <Route path="/403" element={<h2>🚫 Access Denied</h2>} />
     </Routes>
    </motion.div>
   </AnimatePresence>
   <Footer />
  </UserContext.Provider>
 );
};

const App = () => {
 const [user, setUser] = useState(null);
 const [loadingAuth, setLoadingAuth] = useState(true);

  useEffect(() => {
        const saved = localStorage.getItem('user');
        
        // ✅ Add this check to prevent parsing 'undefined'
        if (saved && saved !== 'undefined') {
            try {
                setUser(JSON.parse(saved));
            } catch (error) {
                console.error("Failed to parse user data from localStorage:", error);
                // Optionally clear the invalid data
                localStorage.removeItem('user');
            }
        }
        
        setTimeout(() => setLoadingAuth(false), 400);
    }, []);

 const handleLogin = (userData) => {
  setUser(userData);
  localStorage.setItem('user', JSON.stringify(userData));
 };

 const handleLogout = () => {
  setUser(null);
  localStorage.removeItem('user');
 };

 return (
  <Router>
   {loadingAuth ? null : user ? (
    <InactivityHandler onLogout={handleLogout}>
     <AppLayout user={user} onLogout={handleLogout} />
    </InactivityHandler>
   ) : (
    <div className="auth-container">
     {/* <Spline scene="https://prod.spline.design/jGkNIfannWfzLser/scene.splinecode" />
     <div className="auth-card-overlay"> */}
      <AuthCard onLogin={handleLogin} />
     {/* </div> */}
    </div>
   )}
  </Router>
 );
};



export default App;







// // src/App.js
// import React, { useState, useEffect } from 'react';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Navigate,
//   useLocation,
// } from 'react-router-dom';

// import Navbar from './components/Navbar';
// import Dashboard from './components/Dashboard';
// import PageBuilder from './components/PageBuilder';
// import PageList from './components/PageList';
// import ViewPage from './components/ViewPage';
// import AuthCard from './components/AuthCard';
// import AdminPermissions from './components/AdminPermissions';

// const AppLayout = ({ user, onLogout, onLogin }) => {
//   const location = useLocation();

//   // Hide navbar on auth ("/") route
//   const shouldHideNavbar = location.pathname === '/';

//   // If user not logged in, always show AuthCard
//   if (!user) {
//     return <AuthCard onLogin={onLogin} />;
//   }

//   return (
//     <>
//       {!shouldHideNavbar && <Navbar user={user} onLogout={onLogout} />}
//       <Routes>
//         <Route path="/" element={<Navigate to="/home" />} />
//         <Route path="/home" element={<Dashboard user={user} />} />
//         <Route path="/create" element={<PageBuilder />} />
//         <Route path="/pages" element={<PageList />} />
//         <Route path="/view/:id" element={<ViewPage />} />
//         <Route path="/edit/:id" element={<PageBuilder />} />
//         <Route path="/grant-access" element={<AdminPermissions />} />
//       </Routes>
//     </>
//   );
// };

// const App = () => {
//   const [user, setUser] = useState(null);

//   // Optional: persist login via localStorage
//   useEffect(() => {
//     const saved = localStorage.getItem('user');
//     if (saved) {
//       setUser(JSON.parse(saved));
//     }
//   }, []);

//   const handleLogin = (userData) => {
//     setUser(userData);
//     localStorage.setItem('user', JSON.stringify(userData));
//   };

//   const handleLogout = () => {
//     setUser(null);
//     localStorage.removeItem('user');
//   };

//   return (
//     <Router>
//       <AppLayout user={user} onLogin={handleLogin} onLogout={handleLogout} />
//     </Router>
//   );
// };

// export default App;



// // src/App.js
// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import Navbar from './components/Navbar';
// import Dashboard from './components/Dashboard';
// import PageBuilder from './components/PageBuilder';
// import PageList from './components/PageList';
// import ViewPage from './components/ViewPage';
// import AuthCard from './components/AuthCard';
// import AdminPermissions from './components/AdminPermissions';



// const AppLayout = () => {
//   const location = useLocation();
  
//   // List of routes where navbar should be hidden
//   const hideNavbarRoutes = ['/'];

//   const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

//   return (
//     <>
//       {!shouldHideNavbar && <Navbar />}
//       <Routes>
//         <Route path="/" element={<AuthCard />} />
//         <Route path="/home" element={<Dashboard username="Ajithkumar" />} />
//         <Route path="/create" element={<PageBuilder />} />
//         <Route path="/pages" element={<PageList />} />
//         <Route path="/view/:id" element={<ViewPage />} />
//         <Route path="/edit/:id" element={<PageBuilder />} />
//         <Route path="/grant-access" element={<AdminPermissions />} />
//         {/* Add more routes as needed */}
//       </Routes>
//     </>
//   );
// };

// const App = () => {
//   return (
//     <Router>
//       <AppLayout />
//     </Router>
//   );
// };

// export default App;
